import { RequestError } from "../requestError";
import api from "../axiosBase";
import { getURL } from "../serviceHelper";
import { getEnv } from "../../AppConfigs";
import { requestStatus } from "../../constants";

const SPSiteId = getEnv("REACT_APP_SP_SITE_ID");
const SPListId = getEnv("REACT_APP_SUMMARY_EMPLOYEE_REQUEST_LIST_ID");

const expand =
  "expand=fields(select=Title, eDescription, eContent, eFileContent, eTrainingType,eIssueNumber,eIssueTimes,eIssueEffectiveDate, eMajor, eCourse, eCourseDate, eCourseDateEnd, eDeptHeadComment, eITLeadComment, eITHeadComment, eApprovalComment, eAssigneeComment, eApprovedBy, eApprovedDate,eApprovedStatus, eApprovedByITLead,eApprovedByITLeadStatus, eApprovedByITLeadDate,eApprovedByITHead ,eApprovedByITHeadStatus, eApprovedByITHeadDate, eAssignee,eAssigneeStatus,eAssigneeStatusDate, eRequestStatus, eRequestType, eSoftwareId, eDepartment, eUnit, ePhoneNumber, eComments, eSubRequestsStatus)";

export class HOSummaryEmployeeRequestService {
  static async getSummaryEmployeeRequests(email: string, status?: string) {
    if (
      email.toLowerCase() === "thiennv@viags.vn" ||
      email.toLowerCase() === "namdh@viags.vn" ||
      email.toLowerCase() === "trungdt@viags.vn" ||
      email.toLowerCase() === "hieppt@viags.vn" ||
      email.toLowerCase() === "botit@viags.vn" ||
      email.toLowerCase() === "tienhc@viags.vn" ||
      email.toLowerCase() === "huyth@viags.vn" ||
      email.toLowerCase() === "datnt@viags.vn" ||
      email.toLowerCase() === "sonnhong@viags.vn" ||
      email.toLowerCase() === "taidv@viags.vn" ||
      email.toLowerCase() === "thuonghh@viags.vn" ||
      email.toLowerCase() === "luubd@viags.vn" ||
      email.toLowerCase() === "nghitc@viags.vn" ||
      email.toLowerCase() === "phuocvd@viags.vn"
    ) {
      return api
        .get(
          getURL(
            `/sites/${SPSiteId}/lists/${SPListId}/items?${expand}&$top=1000`
          )
        )
        .then((res) => res.data.value.reverse())
        .catch((err) => {
          throw new RequestError(err);
        });
    } else {
      let filter = `filter=(startswith(fields/eApprovedBy,'${email.toLowerCase()}') or startswith(fields/eApprovedByITLead,'${email.toLowerCase()}') or startswith(fields/eApprovedByITHead,'${email.toLowerCase()}') or startswith(fields/eAssignee,'${email.toLowerCase()}'))`;
      return api
        .get(
          getURL(
            `/sites/${SPSiteId}/lists/${SPListId}/items?${expand}&${filter}&$top=1000`
          )
        )
        .then((res) => res.data.value.reverse())
        .catch((err) => {
          throw new RequestError(err);
        });
    }
  }

  static async getMySummaryEmployeeRequests(email: string) {
    return api
      .get(
        getURL(`/sites/${SPSiteId}/lists/${SPListId}/items?${expand}&$top=1000`)
      )
      .then((res) =>
        res.data.value
          .filter(
            (o: any) =>
              o.createdBy.user.email.toLowerCase() === email.toLowerCase()
          )
          .reverse()
      )
      .catch((err) => {
        throw new RequestError(err);
      });
  }

  static async getDetailsSummaryEmployeeRequest(id: any) {
    return api
      .get(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items/${id}?${expand}`))
      .then((res) => res.data)
      .catch((err) => {
        throw new RequestError(err);
      });
  }

  static async addSummaryEmployeeRequest(fields: any) {
    return api
      .post(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items`), fields)
      .then((res) => res.data)
      .catch((err) => {
        throw new RequestError(err);
      });
  }

  static async updateSummaryEmployeeRequest(id: any, fields: any) {
    return api
      .patch(
        getURL(`/sites/${SPSiteId}/lists/${SPListId}/items/${id}/fields`),
        fields
      )
      .then((res) => res.data)
      .catch((err) => {
        throw new RequestError(err);
      });
  }

  static async getSummaryApprovedRequests(email:string) {
    
    // let filter = `filter=( startswith(fields/eApprovedByITLead,'${email.toLowerCase()}') 
    //                        and startswith(fields/eApprovedByITLeadStatus,'${requestStatus.submitted}') )`;

        let filter = `filter=( 
          startswith(fields/eRequestStatus,'${requestStatus.completed}') 
                              )`;

    return api
      .get(
        getURL(
          `/sites/${SPSiteId}/lists/${SPListId}/items?${expand}&${filter}&$top=1000`
        )
      )
      .then((res) => res.data.value.reverse())
      .catch((err) => {
        throw new RequestError(err);
      });
  }

  static async getSummaryRequireRequests(email:string) {
    
    let filter = `filter=( startswith(fields/eApprovedByITLead,'${email.toLowerCase()}') 
                           and (  startswith(fields/eApprovedByITLeadStatus,'${requestStatus.approved}') 
                                  or  startswith(fields/eApprovedByITLeadStatus,'${requestStatus.rejected}')  
                                ) 
                          )`;

    return api
      .get(
        getURL(
          `/sites/${SPSiteId}/lists/${SPListId}/items?${expand}&${filter}&$top=1000`
        )
      )
      .then((res) => res.data.value.reverse())
      .catch((err) => {
        throw new RequestError(err);
      });
  }
}